import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';

export const InfoItem = ({ icon, label, value, xs, sm }) => (
  <Grid item xs={xs} sm={sm}>
    <Paper
      elevation={0}
      variant='outlined'
      sx={{
        p: 3,
        borderRadius: '16px',
        border: '1px solid #e0e0e0',
        backgroundColor: '#fafafa',
        height: '100%',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: '#f5f5f5',
          borderColor: '#9291ef',
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 16px rgba(146, 145, 239, 0.15)',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Box
          sx={{
            p: 1.5,
            borderRadius: '12px',
            backgroundColor: '#9291ef',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {React.cloneElement(icon, {
            sx: { color: 'white', fontSize: '1.2rem' },
          })}
        </Box>
        <Typography
          variant='subtitle1'
          sx={{ color: '#6c757d', fontWeight: 600, fontSize: '1rem' }}
        >
          {label}
        </Typography>
      </Box>
      <Typography
        variant='body1'
        sx={{
          color: '#2c3e50',
          fontWeight: 500,
          lineHeight: 1.5,
          fontSize: '1rem',
        }}
      >
        {value}
      </Typography>
    </Paper>
  </Grid>
);

export const PromptItem = ({ label, value, xs = 3 }) => (
  <Grid item xs={6} sm={xs}>
    <Paper
      variant='outlined'
      sx={{
        p: 2.5,
        bgcolor: '#f8f9ff',
        borderRadius: '12px',
        border: '1px solid #e0e0e0',
        height: '100%',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: '#f0f2ff',
          borderColor: '#9291ef',
          transform: 'translateY(-1px)',
        },
      }}
    >
      <Typography
        variant='body2'
        sx={{ color: '#6c757d', fontWeight: 600, display: 'block', mb: 1 }}
      >
        {label}
      </Typography>
      <Typography
        variant='body1'
        component='span'
        sx={{ color: '#2c3e50', fontWeight: 600, fontSize: '1rem' }}
      >
        {value}
      </Typography>
    </Paper>
  </Grid>
);
